import React from 'react'

export const StatCard = ({ icon: Icon, value, label, bgColor = 'bg-teal-100', iconColor = 'text-teal-600' }) => {
  return (
    <div className="text-center">
      <div className={`w-12 h-12 ${bgColor} rounded-xl flex items-center justify-center mx-auto mb-2`}>
        <Icon className={`w-6 h-6 ${iconColor}`} />
      </div>
      <div className="text-2xl font-bold text-gray-900">{value}</div>
      <div className="text-sm text-gray-600">{label}</div>
    </div>
  )
}
